import {schema} from 'normalizr'
import {channelSchema} from './channel'
import {userSchema} from './user'

export const organizationSchema = new schema.Entity(
    'organizations',
    {
        channels: [channelSchema],
        creator: userSchema
    },
    {
        idAttribute: 'idname'
    }
)
export const organizationSchemaArray = [
    organizationSchema
]


export const groupSchema = new schema.Entity(
    'groups',
    {},
    {
        idAttribute: 'idname',
    }
)
export const groupMemberSchema = new schema.Entity(
    'group_members',
    {},
    {
        idAttribute: 'id',
    }
)